export default {"src":"/trader-new/_next/static/media/Help.31d2abec.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};